import { render, staticRenderFns } from "./ReviseProcessM.vue?vue&type=template&id=5e3d4a64&"
import script from "./ReviseProcessM.vue?vue&type=script&lang=js&"
export * from "./ReviseProcessM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports